module.exports = __webpack_public_path__ + "static/media/object_immotal2.5a35e183.png";